import { api } from '@services/api'
import { toSearchParams } from '@utils/search'
import { AxiosResponse } from 'axios'
import {
  Location,
  Address,
  LocationParams,
  ResponseCities,
  ResponseState
} from './types'
export * from './types'

export const states = () => api.get<ResponseState>('/addresses/states')

export const cities = (stateId: number) =>
  api.get<ResponseCities>(`/addresses/states/${stateId}/cities`)

export const address = ({ cep }: { cep: string }) =>
  api.get<{ address: Address }>('/addresses/search', {
    params: {
      q: cep
    }
  })

export const index = (
  params: LocationParams = {}
): Promise<AxiosResponse<Location[]>> =>
  api.get<Location[]>('/addresses/locations', {
    params: toSearchParams({
      q: params.name,
      with_lat_long: true
    })
  })

export const LocationsApi = {
  index,
  states,
  cities,
  address
}
